<template>
  <div>
    <div class="row align-items-center mb-3">
      <div class="col-8">
        Sync data with the skoolsync communication module
      </div>
      <div class="col-4 text-right">
        <button
          type="button"
          class="btn btn-primary btn-with-addon"
          @click="handleSync"
        >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-refresh-cw" />
          </span>
          Sync
        </button>
      </div>
    </div>
    <div v-if="data.length">
      <a-divider />
      <div class="air__utils__scrollTable mb-4 mt-2">
        <p class="mb-2 h5 font-weight-bold text-muted">Sync History</p>
          <a-table
            :rowKey="record => record.id"
            :columns="columns"
            :dataSource="data"
            :pagination="false"
            :scroll="{ x: '100%' }"
            :loading="loading"
          >
            <template slot="date" slot-scope="date">
              <span class="font-weight-bold">{{moment(date).format('lll')}}</span>
            </template>
            <template slot="status" slot-scope="status">
              <span class="font-weight-bold">
                <a-tag :color="getStatus(status, 'color')">
                  {{getStatus(status, 'text')}} <a-spin class="ml-2" v-if="status === 2" size="small"/>
                  </a-tag>
              </span>
            </template>
          </a-table>
      </div>
      <div class="text-right" v-if="!(data.length < pageSize)">
        <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :total="meta ? meta.total : 0"
            :pageSize.sync="pageSize"
            v-model="current"
            @change="onChange"
          >
        </a-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'

const columns = [
  {
    title: 'Sync Date',
    className: 'text-left text-gray-6',
    dataIndex: 'created_at',
    scopedSlots: { customRender: 'date' },
  },
  {
    title: 'Status',
    className: 'text-left text-gray-6',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    // sorter: (a, b) => a.name.length - b.name.length,
  },
]

export default {
  name: 'SyncHistoryTable',
  mounted: function() {
    this.getSyncHistory()
    window.Echo.private('SscSync.' + this.user.user.id)
      .listen('.SscSynced', (e) => {
        this.getSyncHistory()
      })
  },
  destroyed: function () {
    window.Echo.leave('SscSync.' + this.user.user.id)
  },
  computed: {
    ...mapState(['user']),
  },
  data: function() {
    return {
      columns,
      loading: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
    }
  },
  methods: {
    moment,
    getSyncHistory() {
      this.loading = true
      this.$http.get('/api/skoolsync/sync_history', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      })
        .then(({ data }) => {
          this.loading = false
          this.data = data.data
          this.meta = data.meta
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getSyncHistory()
    },
    onChange(current) {
      this.current = current
      this.getSyncHistory()
    },
    getStatus(status, type = 'text') {
      if (status === 1) {
        if (type === 'text') {
          return 'Success'
        } else if (type === 'color') {
          return 'green'
        }
      }
      if (status === 2) {
        if (type === 'text') {
          return 'Processing'
        } else if (type === 'color') {
          return 'blue'
        }
      }
      if (status === 0) {
        if (type === 'text') {
          return 'Failed'
        } else if (type === 'color') {
          return 'red'
        }
      }
    },
    handleSync() {
      if (this.data.length && this.data[0].status === 2) {
        this.$info({
          title: 'You have a sync job already running!',
          content: 'You cannot sync right now as another sync job is currently running',
          onOk() {},
        })
      } else {
        this.$confirm({
          title: `Are you sure you want to sync data with the skoolsync communication module?`,
          content: `Clicking Yes will start the sync process?`,
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            this.$nprogress.start()
            this.$http
              .post('/api/skoolsync/create_sync')
              .then((data) => {
                this.$nprogress.done()
                this.$notification['success']({
                  message: 'Sync has started!',
                  description: 'Data is being synced with the skoolsync communication module! You will be notified once completed!',
                })
                this.getSyncHistory()
              })
              .catch(error => {
                this.$nprogress.done()
                this.$neoNotify.error(error)
              })
          },
          onCancel: () => {
          },
        })
      }
    },
  },
}
</script>
